import styled from "@emotion/styled"
import Box from "./Box"
import css from "@styled-system/css"

const Container = styled(Box)`
  ${css({
    maxWidth: "containerWidth",
    mx: "auto",
    my: 0,
    px: [3, 7, 3],
  })}
`

export default Container
